<template>
    <sa-page-layout :btnAnnullaVisible="true" :btnSaveVisible="true" :linkback="linkback" :data="jsonData" @aftersave="onAfterSave" :showModalLoading="showModalLoading" :pathResource="pathResource" class="sa-no-space">
        <template slot="table-body">
            <rsa-configurazione-struttura-provenienza-edit-component ref="RsaConfigurazioneStrutturaProvenienzaEditComponent" @update="onUpdateJsonData"></rsa-configurazione-struttura-provenienza-edit-component>
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneStrutturaProvenienzaEditComponent from "../components/RsaConfigurazioneStrutturaProvenienzaEditComponent.vue";

export default {
    components: { SaPageLayout, RsaConfigurazioneStrutturaProvenienzaEditComponent },
    data() {
        return {
            showModalLoading: false,
            pathResource: "/rsastruttureprovenienza",
            linkback: "/configurazioni/rsastruttureprovenienze",
            jsonData: {},
            id: "-1",
        };
    },
    methods: {
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onAfterSave() {},
    },
};
</script>

<style></style>
